<template>
    <div v-if="modelValue"
         class="select-groups-member-dialogs">

        <SelectGroupDialog v-if="modelValue"
                           :groups="groups"
                           :filter-groups-ids="filterGroupsIds"
                           :filter-users-ids="filterUsersIds"
                           title="Выберите группу:"
                           @hide="onHideGroupDialog"
                           @select:group="onSelectGroup($event)" />

        <SelectUserDialog v-if="showSelectUserDialog"
                          :users="selectedGroup.members"
                          :filter-users-ids="filterUsersIds"
                          title="Выберите участника:"
                          @hide="onHideUserDialog"
                          @select:user="onSelectUser($event)" />
    </div>
</template>

<script>
import SelectGroupDialog from "@/components/SelectGroupDialog.vue";
import SelectUserDialog from "@/components/SelectUserDialog.vue";

export default {
        components: {
            SelectGroupDialog,
            SelectUserDialog
        },

        props: {
            modelValue: Boolean,
            groups: Array,
            filterGroupsIds: Array,
            filterUsersIds: Array
        },

        emits: ["update:modelValue", "select:member"],

        data() {
            return {
                showSelectGroupDialog: false,
                selectedGroup: null,
                showSelectUserDialog: false
            };
        },

        computed: {

        },

        watch: {
            modelValue(newValue) {
                if (newValue) {
                    this.showSelectGroupDialog = true;
                    this.selectedGroup = null;
                    this.showSelectUserDialog = false;
                }
            },

            showSelectGroupDialog(newValue) {
                if (newValue === false) {
                    this.$emit("update:modelValue", newValue);
                }
            }
        },

        methods: {
            onHideGroupDialog() {
                this.showSelectGroupDialog = false;
                this.selectedGroup = null;
            },
            onSelectGroup(group) {
                this.selectedGroup = group;

                if (this.selectedGroup.members === null
                    && group.membersCount > 0) {
                    this.$store.commit("startLoading");

                    this.$store.state.groupsService
                        .getGroupWithUsers(group.guid)
                        .then(response => {
                            this.selectedGroup.members = response.data.members;
                        })
                        .catch(error => this.$store.commit("error", error.message))
                        .finally(() => this.$store.commit("stopLoading"));
                }

                this.showSelectUserDialog = true;
            },
            onHideUserDialog() {
                this.showSelectUserDialog = false;
            },
            onSelectUser(user) {
                this.$emit("select:member", user);

                this.showSelectGroupDialog = false;
                this.showSelectUserDialog = false;
            }
        }
};
</script>

<style lang="scss">
    .select-groups-member-dialogs {
    }
</style>